import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SNModalService } from '@web-services/modal/snModal.service';
import {
	ActionButtonClick,
	ActionButtonResolve,
	GeneralAction,
	GeneralActions
} from '@models/models';
import { IframeService } from '@services/helpers/iframe-service/iframe.service';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'alert-modal',
	template: require('./alert-modal.component.html'),
	styles: [require('./alert-modal.component.scss')]
})
export class AlertModalComponent {
	@Input() title: string;
	@Input() message: string;

	constructor(private ngbActiveModal: NgbActiveModal) {}

	closeModal(): void {
		this.ngbActiveModal.close();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/components/common/buttons-handler/alert-modal/alert-modal.component.ts